import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import AdminLogin from "../pages/admin/Login/Login";
import Dashboard from "../pages/admin/Dashboard/Dashboard";
import PropertyList from "../pages/admin/PropertyList/PropertyList";
import AddProperty from "../pages/admin/AddProperty/AddProperty";
import EditProperty from "../pages/admin/EditProperty/EditProperty";
import CitiesManagement from "../pages/admin/CitiesManagement/CitiesManagement";
import DevelopersManagement from "../pages/admin/DevelopersManagement/DevelopersManagement";
import AmenitiesManagement from "../pages/admin/AmenitiesManagement/AmenitiesManagement";
import Sidebar from "../pages/admin/Sidebar/Sidebar";
import Header from "../pages/admin/Header/Header";

import { isAuthenticated } from "../services/authService";

const ProtectedRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/admin" replace />;
};
// const AdminLayout = ({ children }) => (
//   <div className="admin-shell">
//     <Sidebar />
//     <div className="admin-main">
//       <Header />
//       <div className="admin-content">{children}</div>
//     </div>
//   </div>
// );

const AdminRoutes = () => {
  return (
    <Routes>
      {/* Login – public */}
      <Route path="/admin" element={<AdminLogin />} />

      {/* Dashboard */}
      <Route
        path="/admin/dashboard"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <Dashboard />
            </AdminLayout>
          </ProtectedRoute>
        }
      />

      {/* Properties */}
      <Route
        path="/admin/property-list"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <PropertyList />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/properties"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <PropertyList />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/add-property"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <AddProperty />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/properties/new"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <AddProperty />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/edit-property/:id"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <EditProperty />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/properties/edit/:id"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <EditProperty />
            </AdminLayout>
          </ProtectedRoute>
        }
      />

      {/* Master data */}
      <Route
        path="/admin/cities"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <CitiesManagement />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/developers"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <DevelopersManagement />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/amenities"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <AmenitiesManagement />
            </AdminLayout>
          </ProtectedRoute>
        }
      />

      {/* Fallback → login */}
      <Route path="/admin/*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
};

export default AdminRoutes;